define(function(require) {
    return {
        LAYERS : [
            {
                LAYER_ID : "GEO07E15_SECT_SPES",
                NAME : "Secteurs",
                DOWNLOAD_ACTIVE_SCENARIO_ONLY : false
            }, {
                LAYER_ID : "AD_SPES",
                NAME : "Aires de diffusion",
                DOWNLOAD_ACTIVE_SCENARIO_ONLY : false
            }
        ]
    };
});
